import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBSwitch from "@components/atoms/VdbSwitch";
import LayoutContainer from "@components/layout/LayoutContainer";
import {
  setOverlayState,
  setOverlayWebState,
} from "@redux/slices/appStateSlice";
import {
  useOverlayConfig,
  useOverlayConfigWeb,
} from "@redux/slices/globalSlice";
import LineViewContainer from "@scenes/requests/utils/LineView";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../hooks/useScreenOptionsHooks";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { Platform } from "react-native";

const CoachOverlayScreen = ({ route, modalPadding }: any) => {
  const padding = modalPadding ?? route?.params?.modalPadding;
  const [togglesState, setToggleState] = useState({});
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const dispatch = useDispatch();
  const getOverlayConfig = theme.isLargeScreen
    ? useOverlayConfigWeb()
    : useOverlayConfig();
  const userInfo = useUserInfo();
  const overlayActiveScreensMobile = useSelector(
    (state) => state.appState.overlayActiveScreens
  );
  const overlayActiveScreens =
    Platform.OS === "web"
      ? useSelector((state) => state.appState.overlayActiveScreensWeb)
      : overlayActiveScreensMobile;

  const setOverlay =
    Platform.OS === "web" ? setOverlayWebState : setOverlayState;
  useEffect(() => {
    if (Platform.OS === "web") {
      const updatedState = Object.keys(overlayActiveScreens).reduce(
        (acc, screenName) => {
          acc[screenName] =
            screenName === "MoreScreen"
              ? overlayActiveScreensMobile.MoreScreen
              : overlayActiveScreens[screenName];
          return acc;
        },
        {}
      );
      setToggleState(updatedState);
    } else {
      setToggleState(overlayActiveScreens);
    }
  }, [overlayActiveScreens, overlayActiveScreensMobile]);

  const toggleOverlay = (screenName: any) => {
    setToggleState((prevState) => {
      const newState = !prevState[screenName];

      if (Platform.OS === "web" && screenName === "MoreScreen") {
        Object.keys(getOverlayConfig?.screens).forEach(() => {
          dispatch(
            setOverlayState({ screen: "MoreScreen", isActive: newState })
          );
        });
      } else {
        dispatch(setOverlay({ screen: screenName, isActive: newState }));
      }

      return {
        ...prevState,
        [screenName]: newState,
      };
    });
  };

  return (
    <>
      <LayoutContainer>
        <Container modalPadding={padding}>
          <Spacer size={SpaceType.Big} />
          <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
            {t("coachOverlay.screenText.text")}
          </VDBText>
          <Spacer size={SpaceType.Big} />
          <MenuItemContainer>
            {Object.keys(getOverlayConfig?.screens || {}).map(
              (screenName, index, array) => {
                if (
                  screenName === "AISearchWidget" &&
                  !userInfo?.user?.feature_settings?.enable_chatbot
                ) {
                  return <></>;
                }
                const screenConfig = getOverlayConfig?.screens[screenName];
                const title = screenConfig.title;
                return (
                  <React.Fragment key={index}>
                    <Overlay>
                      <LeftLabelContainer>
                        <VDBText
                          type={
                            togglesState[screenName]
                              ? typography["Body-M"]
                              : typography["Body-R"]
                          }
                          color={
                            togglesState[screenName]
                              ? theme["core-05"]
                              : theme["core-06"]
                          }
                        >
                          {t(title)}
                        </VDBText>
                        <VDBSwitch
                          value={togglesState[screenName]}
                          onValueChange={() => toggleOverlay(screenName)}
                        />
                      </LeftLabelContainer>
                    </Overlay>
                    {index < array.length - 1 && (
                      <LineViewContainer
                        background="core-02"
                        marginLeft={true}
                      />
                    )}
                  </React.Fragment>
                );
              }
            )}
          </MenuItemContainer>
        </Container>
      </LayoutContainer>
    </>
  );
};

const Container = styled.View<{
  modalPadding?: string;
}>`
  padding-horizontal: ${({ theme, modalPadding }) =>
    modalPadding ? modalPadding : theme.isMobile ? "16" : "40"}px;
`;

const Overlay = styled.View`
  padding: ${SpaceType.Double}px;
  flex-direction: column;
`;

const LeftLabelContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const MenuItemContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
`;

export default CoachOverlayScreen;
